module.exports = __webpack_public_path__ + "static/media/banco_popular.eb2e3bde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/payment-method/banco_popular.png
// module id = 1997
// module chunks = 0